<div class="row">
  <div class="col-sm-12">
    <fieldset [disabled]="!isEditing">
      <div class="moveable-item-list" cdkDropList [cdkDropListData]="partnerResolvers" (cdkDropListDropped)="drop($event)">
        @if (partnerResolvers?.length > 0) {
          @for (partnerResolver of partnerResolvers; track partnerResolver) {
            <div class="moveable-item" cdkDrag [cdkDragDisabled]="!isEditing">
              <app-developer-partner-fallback-resolver-config [partnerResolver]="partnerResolver"></app-developer-partner-fallback-resolver-config>
            </div>
          }
        } @else {
          <br />
          <p class="italic">No partner resolver artifacts of this type have been uploaded yet.</p>
        }
      </div>
    </fieldset>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    @if (!isEditing) {
      <div class="btn-group">
        <button class="btn btn-primary" (click)="toggleEditMode()">Edit</button>
      </div>
    }
    @if (isEditing) {
      <div class="btn-group">
        <button class="btn btn-primary" [disabled]="!isFormValid" (click)="save()">Save</button>
      </div>
    }
    @if (isEditing) {
      <div class="btn-group">
        <button class="btn btn-link" (click)="cancelEditMode()">Cancel</button>
      </div>
    }
  </div>
</div>
